import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.less'],
})
export class ResetComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
